/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import { Menu, Dropdown, Image, Space, Modal, Col, Row } from 'antd';
import { adminMenus, deliveryMenus, productMenus, purchaseMenus, salesMenus, inventoryDisableMenus, younoteAdminMenus, helpMenus } from "../../../../config/constant";
import { Link, NavLink, useParams } from "react-router-dom";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from "clsx";
import DropDownIcon from "../../../../assets/images/icon_menus/Drop Down.svg";
import React, { useEffect, useState, Fragment } from "react";
import notificationActions from "../../../Dashboard/redux/actions";
import { Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, Typography, Box, IconButton, InputAdornment } from "@mui/material";
import { MobileMenus } from "./MobileMenus";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import usePrevious from "../Previous";
import NotificationIcon from '../../../../assets/images/icon_menus/Notification-Bell.svg'
import ProfileIcon from '../../../../assets/images/icon_menus/User Profile.svg'
import HelpIcon from '../../../../assets/images/icon_menus/Help Icon.svg'
import actions from "../../../Auth/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { logoutUser } from '../../../../helpers/utilities';
import CloseIcon from "../Icons/CloseIcon";
import moment from 'moment';
import { CustomerLeaderBoard, SalesPaymentStatement, StaffSalesCollectionStatement, SalesPriceDeviation, Top10Supplier, ResaleValueReport, StockValueReport, TransferValueReport, NetOrderReport, ProductAnalysis, ProductGroupAnalysis, TopProductsSupply, SalesLocation, CustomerAgedDues, InactiveCustomers } from "../ReportEnquiry";
import { getUserId, checkPermission, checkModulePermission, idNamingConversion } from '../../../../helpers/utilities';
import { emptyValidation, customEmailValidation as uniqueEmail, customPhoneValidation, customPasswordMatch, customPassword } from "../../../../helpers/validation";
import Visibility from "../Icons/Visibility";
import VisibilityOff from "../Icons/VisibilityOff";
import ShortCutKeys from "../ShortCutKeys";
import PDFViewer from "../PDFViewer";
const { SubMenu } = Menu;

export const Menus = (props) => {
    const { history, notificationClick } = props;
    //Change Password
    const { loggedInUser } = useSelector(state => state.authReducer);
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const [isCPModalVisible, setIsCPModalVisible] = useState(false);
    const { notificationDetails, editNotificationDetails, editNotificationLoader } = useSelector(state => state.commonReducer);
    const { changeEmailDetails, changeEmailLoader, changeEmailError, changePasswordLoader, changePasswordDetails, changePasswordError, verifyPasswordDetails,
        verifyPasswordError, verifyPasswordLoader } = useSelector(state => state.authReducer);

    const [changeEmailErrorMessage, setChangeEmailErrorMessage] = useState(false);
    const [changeMobileErrorMessage, setChangeMobileErrorMessage] = useState(false);
    const [notificationVisible, setNotificationVisible] = useState(false);

    const [verifyPasswordEmailErrorMessage, setVerifyPasswordEmailErrorMessage] = useState(false);
    const [verifyPasswordMobileErrorMessage, setVerifyPasswordMobileErrorMessage] = useState(false);
    const [passwordOldShown, setPasswordOldShown] = useState(false);
    const [passwordNewShown, setPasswordNewShown] = useState(false);
    const [passwordConfirmShown, setPasswordConfirmShown] = useState(false);
    const [passwordEmailShown, setPasswordEmailShown] = useState(false);
    const [passwordMobileShown, setPasswordMobileShown] = useState(false);


    const [changeEmail, setChangeEmail] = useState('');
    const [changeMobile, setChangeMobile] = useState('');
    const [notification, setNotification] = useState(false);
    const { notificationId } = useParams();
    const [leaderBoardVisible, setLeaderBoardVisible] = useState(false);
    const [salesPaymentVisible, setSalesPaymentVisible] = useState(false);
    const [topSupplierVisible, setTopSupplierVisible] = useState(false);
    const [resaleValueVisible, setResaleValueVisible] = useState(false);
    const [stockValueVisible, setStockValueVisible] = useState(false);
    const [transferValueVisible, setTransferValueVisible] = useState(false);
    const [netOrderVisible, setNetOrderVisible] = useState(false);
    const [productAnalysisVisible, setProductAnalysisVisible] = useState(false);
    const [productGroupAnalysisVisible, setProductGroupAnalysisVisible] = useState(false);
    const [topProductsSupplyVisible, setTopProductsSupplyVisible] = useState(false);
    const [salesLocationVisible, setSalesLocationVisible] = useState(false);
    const [customerAgedDuesVisible, setCustomerAgedDuesVisible] = useState(false);
    const [inaciveCustomersVisible, setInaciveCustomersVisible] = useState(false);
    const [staffSalesCollectionVisible, setStaffSalesCollectionVisible] = useState(false);
    const [salesPriceDeviationVisible, setSalesPriceDeviationVisible] = useState(false);

    const [menuTitle, setMenuTitle] = useState('');
    const prevEditNotificationDetails = usePrevious(editNotificationDetails);
    const prevChangePasswordDetails = usePrevious(changePasswordDetails);
    const prevChangePasswordError = usePrevious(changePasswordError);
    const prevVerifyPasswordDetails = usePrevious(verifyPasswordDetails);
    const prevVerifyPasswordError = usePrevious(verifyPasswordError);
    const prevChangeEmailDetails = usePrevious(changeEmailDetails);
    const prevChangeEmailError = usePrevious(changeEmailError);



    const showCPModal = () => {
        setIsCPModalVisible(true);
    };

    const handleCPOk = () => {
        setIsCPModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
        document.getElementById("change-password-submit").reset();
    };

    const handleCPCancel = () => {
        setIsCPModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
        document.getElementById("change-password-submit").reset();
    };

    //Change Email
    const [isEmailModalVisible, setIsEmailModalVisible] = useState(false);
    const [isChangeEmailModalVisible, setIsChangeEmailModalVisible] = useState(false);
    const [isChangeMobileModalVisible, setIsChangeMobileModalVisible] = useState(false);
    const [shortCutVisible, setShortCutVisible] = useState(false);
    const [pdfVisible, setPdfVisible] = useState(false);
    const [pdfName, setPdfName] = useState('');


    const showEmailModal = () => {
        setIsEmailModalVisible(true);
    };

    const handleEmailOk = () => {
        setIsEmailModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleEmailCancel = () => {
        setIsEmailModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleChangeEmailOk = () => {
        setIsChangeEmailModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleChangeEmailCancel = () => {
        setIsChangeEmailModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleChangeMobileOk = () => {
        setIsChangeMobileModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleChangeMobileCancel = () => {
        setIsChangeMobileModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    //Change Mobile Number
    const [isMobileModalVisible, setIsMobileModalVisible] = useState(false);
    const showMobileModal = () => {
        setIsMobileModalVisible(true);
    };

    const handleMobileOk = () => {
        setIsMobileModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleMobileCancel = () => {
        setIsMobileModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    //Change Language
    const [isLangModalVisible, setIsLangModalVisible] = useState(false);
    const showLangModal = () => {
        setIsLangModalVisible(true);
    };

    const handleLangOk = () => {
        setIsLangModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleLangCancel = () => {
        setIsLangModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const [password, setPassword] = useState('');
    const [field, setField] = useState(false);
    const dispatch = useDispatch();
    const handleVerifyPassword = (e, field) => {
        let emptyVerfifyPassword = emptyValidation('Verify Password', password);
        e.preventDefault();
        emptyAllState();
        if (emptyVerfifyPassword.isValid) {
            dispatch({
                type: actions.VERIFY_PASSWORD_START,
                verifyPasswordData: {
                    password: password
                }
            });
        } else {
            if (emptyVerfifyPassword.errors) {
                if (field === 'mobile') {
                    setVerifyPasswordMobileErrorMessage(emptyVerfifyPassword.errors);
                } else {
                    setVerifyPasswordEmailErrorMessage(emptyVerfifyPassword.errors);
                }
            }
        }
        setField(field);
    }

    const [successModalVisible, setSuccessModalVisible] = useState(false);

    const handleSuccessOk = () => {
        setSuccessModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    const handleSuccessCancel = () => {
        setSuccessModalVisible(false);
        emptyAllState();
        emptyAllStateInput();
    };

    useEffect(() => {
        if (prevChangePasswordDetails !== undefined && changePasswordDetails && prevChangePasswordDetails !== changePasswordDetails) {
            toast.dismiss();
            toast('Your Password has been successfully changed');
            setIsCPModalVisible(false);
            dispatch({
                type: actions.CLEAR_PASSWORD_START
            });
            emptyAllStateInput();
        } else if (prevChangePasswordError !== undefined && changePasswordError && prevChangePasswordError !== changePasswordError) {
            if (changePasswordError && changePasswordError.error.message === 'Incorrect old Password') {
                setErroroldPassword(changePasswordError.error.message);
            } else if (changePasswordError && changePasswordError.error.message === "Password's doesn't match") {
                setErrornewPassword(changePasswordError.error.message);
            }
        }
    }, [changePasswordDetails, changePasswordError]);

    useEffect(() => {
        if (prevVerifyPasswordDetails !== undefined && verifyPasswordDetails && prevVerifyPasswordDetails !== verifyPasswordDetails) {
            if (field === 'mobile') {
                setIsMobileModalVisible(false);
                setIsChangeMobileModalVisible(true);
            } else {
                setIsEmailModalVisible(false);
                setIsChangeEmailModalVisible(true);
            }
            dispatch({
                type: actions.CLEAR_PASSWORD_START
            });
            emptyAllStateInput();
            document.getElementById("verify-password").reset();
        } else if (prevVerifyPasswordError !== undefined && verifyPasswordError && prevVerifyPasswordError !== verifyPasswordError) {
            if (field === 'mobile') {
                setVerifyPasswordMobileErrorMessage(verifyPasswordError.error.message);
            } else {
                setVerifyPasswordEmailErrorMessage(verifyPasswordError.error.message);
            }

        }
    }, [verifyPasswordDetails, verifyPasswordError]);


    const handleChangeEmail = (e) => {
        e.preventDefault();
        let customEmailValidation = uniqueEmail('Email', changeEmail);
        emptyAllState();
        if (customEmailValidation.isValid) {
            dispatch({
                type: actions.CHANGE_EMAIL_START,
                changeEmailData: {
                    mail: changeEmail
                }
            });
        } else {
            if (customEmailValidation.errors) {
                setChangeEmailErrorMessage(customEmailValidation.errors);
            }
        }

    }

    const handleChangeMobile = (e) => {
        e.preventDefault();
        let mobileValidation = customPhoneValidation('Mobile', changeMobile);
        emptyAllState();
        if (mobileValidation.isValid) {
            dispatch({
                type: actions.CHANGE_EMAIL_START,
                changeEmailData: {
                    mobile: changeMobile
                }
            });
        } else {
            if (mobileValidation.errors) {
                setChangeMobileErrorMessage(mobileValidation.errors);
            }
        }
    }

    const emptyAllState = () => {
        setErroroldPassword(false);
        setErrornewPassword(false);
        setErrorconfirmPassword(false);
        setVerifyPasswordMobileErrorMessage(false);
        setVerifyPasswordEmailErrorMessage(false);
        setChangeMobileErrorMessage(false);
        setChangeEmailErrorMessage(false);
        setPasswordOldShown(false);
        setPasswordNewShown(false);
        setPasswordConfirmShown(false);
        setPasswordEmailShown(false);
        setPasswordMobileShown(false);
    }

    const emptyAllStateInput = () => {
        setPassword('');
        setChangeEmail('');
        setChangeMobile('');
        setoldPassword('');
        setnewPassword('');
        setconfirmPassword('');
    }
    const [successMessage, setSuccessMessage] = useState(false);

    useEffect(() => {
        if (prevChangeEmailDetails !== undefined && changeEmailDetails && prevChangeEmailDetails !== changeEmailDetails) {
            setIsChangeEmailModalVisible(false);
            setIsChangeMobileModalVisible(false);
            setSuccessModalVisible(true);
            dispatch({
                type: actions.CLEAR_PASSWORD_START
            });
            if (field === 'mobile') {
                let s_message = <div dangerouslySetInnerHTML={{ __html: 'The Mobile Number <span class="bold">+91 ' + changeMobile + '</span> has been successfully updated as your registered Mobile Number <br/><br/> You will continue to receive OTP to this new Mobile Number' }} />
                setSuccessMessage(s_message);
            } else {
                let s_message = <div dangerouslySetInnerHTML={{ __html: 'The  Email ID <span class="bold">' + changeEmail + '</span> has been successfully updated as your registered Email ID <br/><br/> You will continue to receive OTP to this new Email ID' }} />
                setSuccessMessage(s_message);
            }
        } else if (prevChangeEmailError !== undefined && changeEmailError && prevChangeEmailError !== changeEmailError) {
            let text = changeEmailError.error.message;
            if (text.includes('mobile_UNIQUE')) {
                setChangeMobileErrorMessage('Mobile number already exist');
            } else if (text.includes('email_UNIQUE')) {
                setChangeEmailErrorMessage('Email already exist');
            }
        }
    }, [changeEmailDetails, changeEmailError]);

    const [oldPassword, setoldPassword] = useState('');
    const [newPassword, setnewPassword] = useState('');
    const [confirmPassword, setconfirmPassword] = useState('');

    const [errorOldPassword, setErroroldPassword] = useState(false);
    const [errorNewPassword, setErrornewPassword] = useState(false);
    const [errorConfirmPassword, setErrorconfirmPassword] = useState(false);

    const handleChangePassword = (e) => {
        e.preventDefault();
        let emptyOldPassword = emptyValidation('Old Password', oldPassword);
        let emptyNewPassword = customPassword('New Password', newPassword);
        let emptyConfirmPassword = customPasswordMatch('Confirm Password', newPassword, confirmPassword);
        emptyAllState();
        if (emptyOldPassword.isValid && emptyNewPassword.isValid && emptyConfirmPassword.isValid) {
            dispatch({
                type: actions.CHANGE_PASSWORD_START,
                token: loggedInUser,
                changePasswordData: {
                    oldPassword: oldPassword,
                    newPassword: newPassword,
                    confirmPassword: confirmPassword
                }
            });
        } else {
            if (emptyOldPassword.errors !== '') {
                setErroroldPassword(emptyOldPassword.errors);
            } if (emptyNewPassword.errors !== '') {
                setErrornewPassword(emptyNewPassword.errors);
            } if (emptyConfirmPassword.errors !== '') {
                setErrorconfirmPassword(emptyConfirmPassword.errors);
            }
        }
    }

    const handleClearNotification = (type = 'dashboard') => {
        setNotification(true);
        dispatch({
            type: notificationActions.EDIT_NOTIFICATION_START,
            url: `notifications/clearAll/${type}`,
            title: 'Notification',
        });
        setNotificationVisible(true);
    }

    const handleClickNotification = (id, type = "dashboard") => {
        let details = '';
        setNotification(true);
        if (type === 'menu') {
            details = { is_seen_in_dashboard: true };
        } else {
            details = { is_seen_in_dashboard: true, is_seen: true };
        }

        dispatch({
            type: notificationActions.EDIT_NOTIFICATION_START,
            url: 'notifications',
            title: 'Notification',
            id: id,
            details: details
        });
        if (type !== 'menu') {
            history.push(`/notification/${id}`);
        }
    }

    const loadTasksNotification = () => {
        let filter = { ["and"]: [{ toUserId: getUserId() }] };
        dispatch({
            type: notificationActions.NOTIFICATION_START,
            url: 'notifications',
            filter: {
                where: filter,
                order: 'id DESC',
            }
        });
    }

    useEffect(() => {
        if (prevEditNotificationDetails !== undefined && editNotificationLoader && prevEditNotificationDetails !== editNotificationLoader) {
            if (notification) {
                setTimeout(() => {
                    loadTasksNotification();
                    setNotification(false);
                }, 200)
            }
        }
    }, [editNotificationLoader]);

    const handleVisibleChange = (flag) => {
        setNotificationVisible(flag);
    };

    const handleNotificationAll = () => {
        if (notificationId === undefined) {
            history.push('/notification/all');
        } else {
            notificationClick('all');
        }
    }

    const handleMenuOnClick = (name, view = '') => {
        setMenuTitle(name);
        if (name === 'Customer Invoice Report') {
            setLeaderBoardVisible(true);
        } else if (name === 'Sales & Payment- Statement') {
            setSalesPaymentVisible(true);
        } else if (name === 'Top 10 Suppliers') {
            setTopSupplierVisible(true);
        } else if (name === 'Resale Value Report') {
            setResaleValueVisible(true);
        } else if (name === 'Stock Value Report') {
            setStockValueVisible(true);
        } else if (name === 'Transfer Value Report') {
            setTransferValueVisible(true);
        } else if (name === 'Net Order Report') {
            setNetOrderVisible(true);
        } else if (name === 'Product-wise Analysis') {
            setProductAnalysisVisible(true);
        } else if (name === 'Sales By Location') {
            setSalesLocationVisible(true);
        } else if (name === 'Customer Aged Dues') {
            setCustomerAgedDuesVisible(true);
        } else if (name === 'Inactive Customers') {
            setInaciveCustomersVisible(!inaciveCustomersVisible)
        } else if (name === 'Shortcut Keys') {
            setShortCutVisible(!shortCutVisible)
        } else if (name === 'Product Group wise Analysis') {
            setProductGroupAnalysisVisible(true);
        } else if (name === 'Top Products Supply') {
            setTopProductsSupplyVisible(true);
        } else if (name === 'Staff sales and collection') {
            setStaffSalesCollectionVisible(true);
        } else if (name === 'Sales Price Deviation') {
            setSalesPriceDeviationVisible(true);
        } else if (name === 'Pdf View') {
            setPdfVisible(!pdfVisible);
            if (view) {
                setPdfName(view);
            }
        } else if (name === 'Video View') {
            setPdfVisible(!pdfVisible);
            if (view) {
                setPdfName(view);
            }
        }
    }


    const classes = customStyles();
    return (
        <Fragment>
            <div className={clsx(classes.menu, classes.mainMenu, classes.fonSize14)}>
                {
                    checkModulePermission(salesMenus.menu) &&
                    <Dropdown
                        className={clsx(classes.primaryMenuColor, classes.iconDropDown)}
                        placement="bottomLeft"
                        overlay={
                            <Menu className={clsx(classes.MenuColors, classes.dropDownadjust)}>
                                {salesMenus.sub.map(menus => (
                                    <SubMenu
                                        className={classes.menuArrowIcon}
                                        id={idNamingConversion(menus.menu)}
                                        key={menus.menu} title={menus.menu}>
                                        {menus.sub.map((submenu, i) => (
                                            <Fragment key={`${submenu.menu}_${i}`}>
                                                {
                                                    checkPermission(submenu.menu, 'Sales') &&
                                                    <>
                                                        {
                                                            submenu.onClick ?
                                                                <Menu.Item id={idNamingConversion(submenu.menu)} onClick={() => handleMenuOnClick(submenu.menu)} key={`${submenu.menu}${i}`}>
                                                                    <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                        {submenu.menu}
                                                                    </Link>
                                                                </Menu.Item> :
                                                                <Menu.Item id={idNamingConversion(submenu.menu)} key={`${submenu.menu}${i}`}>
                                                                    <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                        {submenu.menu}
                                                                    </Link>
                                                                </Menu.Item>
                                                        }
                                                    </>
                                                }
                                            </Fragment>
                                        ))}
                                    </SubMenu>
                                ))}
                            </Menu>
                        }>
                        <Space id={idNamingConversion(salesMenus.menu)}>
                            <NavLink tabIndex={-1} to={salesMenus.link} activeClassName={classes.menuActive}>{salesMenus.menu}</NavLink>
                            <Image
                                src={DropDownIcon}
                                preview={false}
                            />
                        </Space>
                    </Dropdown>
                }
                {
                    checkModulePermission(purchaseMenus.menu) &&
                    <Dropdown
                        className={clsx(classes.primaryMenuColor, classes.iconDropDown)}
                        placement="bottomLeft"
                        overlay={
                            <Menu className={clsx(classes.MenuColors, classes.dropDownadjust)}>
                                {purchaseMenus.sub.map(menus => (
                                    <SubMenu
                                        className={classes.menuArrowIcon}
                                        id={idNamingConversion(menus.menu)}
                                        key={menus.menu} title={menus.menu}>
                                        {menus.sub.map((submenu, i) => (
                                            <Fragment key={`${submenu.menu}_${i}`}>
                                                {
                                                    checkPermission(submenu.menu, 'Purchase') &&
                                                    <>
                                                        {
                                                            submenu.onClick ?
                                                                <Menu.Item id={idNamingConversion(submenu.menu)} onClick={() => handleMenuOnClick(submenu.menu)} key={`${submenu.menu}${i}`}>
                                                                    <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                        {submenu.menu}
                                                                    </Link>
                                                                </Menu.Item> :
                                                                <Menu.Item id={idNamingConversion(submenu.menu)} key={`${submenu.menu}${i}`}>
                                                                    <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                        {submenu.menu}
                                                                    </Link>
                                                                </Menu.Item>
                                                        }
                                                    </>
                                                }
                                            </Fragment>
                                        ))}
                                    </SubMenu>
                                ))}
                            </Menu>
                        }>
                        <Space id={idNamingConversion(purchaseMenus.menu)}>
                            <NavLink tabIndex={-1} to={purchaseMenus.link} activeClassName={classes.menuActive}>{purchaseMenus.menu}</NavLink>
                            <Image
                                src={DropDownIcon}
                                preview={false}
                            />
                        </Space>
                    </Dropdown>
                }
                {
                    checkModulePermission(deliveryMenus.menu) &&
                    <Dropdown
                        className={clsx(classes.primaryMenuColor, classes.iconDropDown)}
                        placement="bottomLeft"
                        overlay={
                            <Menu className={clsx(classes.MenuColors, classes.dropDownadjust)}>
                                {deliveryMenus.sub.map(menus => (
                                    <SubMenu
                                        className={classes.menuArrowIcon}
                                        id={idNamingConversion(menus.menu)}
                                        key={menus.menu} title={menus.menu}>
                                        {menus.sub.map((submenu, i) => (
                                            <Fragment key={`${submenu.menu}_${i}`}>
                                                {
                                                    checkPermission(submenu.menu, 'Delivery') && <Menu.Item id={idNamingConversion(submenu.menu)} key={`${submenu.menu}${i}`}>
                                                        <Link to={submenu.link} style={{ color: '#317787' }}>
                                                            {submenu.menu}
                                                        </Link>
                                                    </Menu.Item>
                                                }
                                            </Fragment>
                                        ))}
                                    </SubMenu>
                                ))}
                            </Menu>
                        }>
                        <Space id={idNamingConversion(deliveryMenus.menu)}>
                            <NavLink tabIndex={-1} to={deliveryMenus.link} activeClassName={classes.menuActive}>{deliveryMenus.menu}</NavLink>
                            <Image
                                src={DropDownIcon}
                                preview={false}
                            />
                        </Space>
                    </Dropdown>
                }
                {
                    checkModulePermission(productMenus.menu) &&
                    <Dropdown
                        className={clsx(classes.primaryMenuColor, classes.iconDropDown)}
                        placement="bottomLeft"

                        overlay={
                            <Menu key={'productMenu'} className={clsx(classes.MenuColors, classes.dropDownadjust)}>
                                {productMenus.sub.map((menus, i) => {
                                    return (
                                        <SubMenu
                                            className={clsx(classes.menuArrowIcon)}
                                            id={idNamingConversion(menus.menu)}
                                            key={`${menus.menu}_${i}`} gap={0} title={menus.menu}>
                                            {
                                                menus.sub.map((submenu, i) => (
                                                    <Fragment key={`${submenu.menu}_${i}`}>
                                                        {
                                                            submenu.menu === 'Units' ?
                                                                <SubMenu
                                                                    className={classes.menuArrowIcon}
                                                                    key={`${submenu.menu}${i}`}
                                                                    title={submenu.menu}>
                                                                    {submenu.sub.map((menus, i) => (
                                                                        <Fragment key={`__${i}`}>
                                                                            {
                                                                                checkPermission(menus.menu, 'Product') && <Menu.Item key={i} id={idNamingConversion(menus.menu)}>
                                                                                    <Link to={menus.link} style={{ color: '#317787' }}>
                                                                                        {menus.menu}
                                                                                    </Link>
                                                                                </Menu.Item>
                                                                            }
                                                                        </Fragment>
                                                                    ))}
                                                                </SubMenu>
                                                                :
                                                                checkPermission(submenu.menu, 'Product') && <>
                                                                    {
                                                                        submenu.onClick ?
                                                                            <Menu.Item id={idNamingConversion(submenu.menu)} onClick={() => handleMenuOnClick(submenu.menu)} key={`${submenu.menu}${i}`}>
                                                                                <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                                    {submenu.menu}
                                                                                </Link>
                                                                            </Menu.Item> :
                                                                            <Menu.Item id={idNamingConversion(submenu.menu)} className={clsx(inventoryDisableMenus[submenu.menu], submenu.menu, { [classes.displayInventoryNone]: !parameterDetails?.inventoryTransaction && inventoryDisableMenus.includes(submenu.menu) })} key={`${submenu.menu}${i}`}>
                                                                                <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                                    {submenu.menu}
                                                                                </Link>
                                                                            </Menu.Item>
                                                                    }
                                                                </>
                                                        }
                                                    </Fragment>
                                                ))
                                            }
                                        </SubMenu>
                                    )
                                })}
                            </Menu>
                        }>
                        <Space id={idNamingConversion(productMenus.menu)}>
                            <NavLink tabIndex={-1} to={productMenus.link} activeClassName={classes.menuActive}>{productMenus.menu}</NavLink>
                            <Image
                                src={DropDownIcon}
                                preview={false}
                            />
                        </Space>
                    </Dropdown>
                }
                {
                    checkModulePermission(adminMenus.menu) &&
                    <Dropdown
                        className={clsx(classes.primaryMenuColor, classes.iconDropDown)}
                        placement="bottomLeft"
                        overlay={
                            <Menu className={clsx(classes.MenuColors, classes.dropDownadjust)}>
                                {adminMenus?.sub?.map((menus, i) => (
                                    <Fragment key={`${menus.menu}${i}`}>
                                        {
                                            menus?.sub ?
                                                <SubMenu
                                                    className={classes.menuArrowIcon}
                                                    key={menus.menu}
                                                    id={idNamingConversion(menus.menu)}
                                                    title={menus.menu} link={menus.link}>
                                                    {menus?.sub && menus?.sub?.map((submenu, i) => (
                                                        <Fragment key={`${submenu.menu}_${i}`}>
                                                            {
                                                                submenu.menu === 'Address' || submenu.menu === 'Units' ?
                                                                    <SubMenu
                                                                        className={classes.menuArrowIcon}
                                                                        key={`${submenu.menu}${i}`} title={submenu.menu}>
                                                                        {submenu.sub.map((menus, i) => (
                                                                            <Fragment key={`${submenu.menu}_${i}`}>
                                                                                {
                                                                                    checkPermission(menus.menu, 'Admin') &&
                                                                                    <Menu.Item id={idNamingConversion(submenu.menu)} key={`${submenu.menu}_${i}`}>
                                                                                        <Link to={menus.link} style={{ color: '#317787' }}>
                                                                                            {menus.menu}
                                                                                        </Link>
                                                                                    </Menu.Item>
                                                                                }
                                                                            </Fragment>
                                                                        ))}
                                                                    </SubMenu>
                                                                    :
                                                                    <Fragment key={`${submenu.menu}_${i}`}>
                                                                        {checkPermission(submenu.menu, 'Admin') &&
                                                                            <Menu.Item id={idNamingConversion(submenu.menu)} key={`${submenu.menu}${i}`}>
                                                                                <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                                    {submenu.menu}
                                                                                </Link>
                                                                            </Menu.Item>}
                                                                    </Fragment>
                                                            }
                                                        </Fragment>
                                                    ))}
                                                </SubMenu> : <Fragment key={`${menus.menu}_${i}`}>
                                                    {checkPermission(menus.menu, 'Admin') &&
                                                        <Menu.Item id={idNamingConversion(menus.menu)} key={`${menus.menu}${i}`}>
                                                            <Link to={menus.link} style={{ color: '#317787' }}>
                                                                {menus.menu}
                                                            </Link>
                                                        </Menu.Item>}
                                                </Fragment>
                                        }
                                    </Fragment>
                                ))}
                            </Menu>
                        }>
                        <Space id={idNamingConversion(adminMenus.menu)}>
                            <NavLink tabIndex={-1} to={adminMenus.link} activeClassName={classes.menuActive}>{adminMenus.menu}</NavLink>
                            <Image
                                src={DropDownIcon}
                                preview={false}
                            />
                        </Space>
                    </Dropdown>
                }
                {
                    checkModulePermission(younoteAdminMenus.menu) &&
                    <Dropdown
                        className={clsx(classes.primaryMenuColor, classes.iconDropDown)}
                        placement="bottomLeft"
                        overlay={
                            <Menu className={clsx(classes.MenuColors, classes.dropDownadjust)}>
                                {younoteAdminMenus.sub.map(menus => (
                                    <SubMenu
                                        className={classes.menuArrowIcon}
                                        id={idNamingConversion(menus.menu)}
                                        key={menus.menu} title={menus.menu}>
                                        {menus.sub.map((submenu, i) => (
                                            <Fragment key={`${submenu.menu}_${i}`}>
                                                {
                                                    submenu.menu === 'Address' || submenu.menu === 'Units' ?
                                                        <SubMenu
                                                            className={classes.menuArrowIcon}
                                                            key={`${submenu.menu}${i}`} title={submenu.menu}>
                                                            {submenu.sub.map((menus, i) => {
                                                                return (
                                                                    checkPermission(menus.menu, 'Younote Admin') && <Menu.Item id={idNamingConversion(menus.menu)} key={`${younoteAdminMenus.menu}_${submenu.menu}${i}`}>
                                                                        <Link to={menus.link} style={{ color: '#317787' }}>
                                                                            {menus.menu}
                                                                        </Link>
                                                                    </Menu.Item>
                                                                )
                                                            })}
                                                        </SubMenu>
                                                        :
                                                        <Fragment key={`${submenu.menu}_${i}`}>
                                                            {
                                                                checkPermission(submenu.menu, 'Younote Admin') && <Menu.Item id={idNamingConversion(menus.menu)} key={`${younoteAdminMenus.menu}_${submenu.menu}${i}`}>
                                                                    <Link to={submenu.link} style={{ color: '#317787' }}>
                                                                        {submenu.menu}
                                                                    </Link>
                                                                </Menu.Item>
                                                            }
                                                        </Fragment>
                                                }
                                            </Fragment>
                                        ))}
                                    </SubMenu>
                                ))}
                            </Menu>
                        }
                    >
                        <Space id={idNamingConversion(younoteAdminMenus.menu)}>
                            <NavLink tabIndex={-1} to={younoteAdminMenus.link} activeClassName={classes.menuActive}>{younoteAdminMenus.menu}</NavLink>
                            <Image
                                src={DropDownIcon}
                                preview={false}
                            />
                        </Space>
                    </Dropdown>
                }

                <Space size={[0, 0]} className={clsx(classes.menuIcons)} align={'center'}>
                    <Space size={[0, 0]} className={clsx(classes.padddingIcons)}>
                        {/* <Image
                        width={16}
                        src={SearchIcon}
                        preview={false}
                    /> */}
                    </Space>
                    <Dropdown
                        placement="bottomRight"
                        trigger={['click']}
                        open={notificationVisible}
                        onOpenChange={(flag) => handleVisibleChange(flag)}
                        onClick={() => handleClearNotification('alert')}
                        className={clsx(classes.padddingIconsProfile, classes.primaryMenuColor)}
                        arrow={true}
                        overlayClassName={classes.notificationDropDown}
                        overlay={
                            notificationDetails?.length > 0 && notificationDetails?.filter((el) => { return el.is_seen_in_dashboard === false })?.length > 0 ?
                                <Menu className={clsx(classes.bigMenuColors, { [classes.loadingA]: notification })}>
                                    <Menu.Item id={"clear-all"} key={"clear-all"} onClick={() => handleClearNotification('dashboard')}>Clear all</Menu.Item>
                                    {
                                        notificationDetails?.length > 0 && notificationDetails?.filter((el) => { return el.is_seen_in_dashboard === false }).map((data, i) => (
                                            <Menu.Item key={i}>
                                                <Row>
                                                    <Col span={20} className={clsx(classes.notificationText, classes.fonSize13)}>
                                                        <span onClick={() => handleClickNotification(data.id)}>{data?.description}</span>
                                                    </Col>
                                                    <Col span={4} className={clsx(classes.textAlignRight, classes.notificationRight, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.paddingright0)}>
                                                        <span className={clsx(classes.disInline, classes.verticalAlignMiddle)}>{moment(new Date(data?.createTs)).fromNow([true])}</span> <CloseIcon className={clsx(classes.notificationClose, classes.disInline, classes.verticalAlignMiddle)} onClick={() => handleClickNotification(data.id, 'menu')} />
                                                    </Col>
                                                </Row>
                                            </Menu.Item>
                                        ))}
                                </Menu> : <Menu className={clsx(classes.bigMenuColors, classes.bigMenuColorsNo)}>
                                    <Menu.Item id={"no_notification"} key={"no_notification"}>
                                        <Row>
                                            <Col span={24} className={clsx(classes.noNotificationText, classes.fonSize13, classes.textAlignCenter)}>
                                                No new notifications to show, <span onClick={() => handleNotificationAll()} className={clsx(classes.bold, classes.customLink)}>Click here</span> to view older messages
                                            </Col>
                                        </Row>
                                    </Menu.Item>
                                </Menu>
                        }>
                        <div className={clsx(classes.profileIconHover)} id={idNamingConversion('Notification')}>
                            {
                                notificationDetails?.length > 0 && notificationDetails?.filter((el) => { return el.is_seen_in_alert === false }).length > 0 &&
                                <div className={classes.notificationCount}>
                                    <span>{notificationDetails?.filter((el) => { return el.is_seen_in_alert === false }).length}</span>
                                </div>
                            }
                            <Image src={NotificationIcon} preview={false} />
                        </div>
                    </Dropdown>
                    <Dropdown
                        placement="bottomRight"
                        className={clsx(classes.padddingIconsProfile, classes.primaryMenuColor)}
                        overlay={
                            <Menu className={clsx(classes.MenuColors)}>
                                <Menu.Item key={55} className={clsx(classes.submenuArrow)}></Menu.Item>
                                <Menu.Item id={idNamingConversion('My Profile')} key={'my-profile'}>
                                    <Link to={'/my-profile'}>My Profile</Link>
                                </Menu.Item>
                                <Menu.Item id={idNamingConversion('Logout')} key={'logout'} onClick={() => logoutUser(props)}>
                                    Logout
                                </Menu.Item>
                                <Menu.Item id={idNamingConversion('Change Password')} key={'change-password'} onClick={() => showCPModal()}>
                                    Change Password
                                </Menu.Item>
                                <Menu.Item id={idNamingConversion('Change Email ID')} key={'change-email-id'} onClick={() => showEmailModal()}>
                                    Change Email ID
                                </Menu.Item>
                                <Menu.Item id={idNamingConversion('Change Mobile Number')} key={'change-mobile-number'} onClick={() => showMobileModal()}>
                                    Change Mobile Number
                                </Menu.Item>
                                <Menu.Item id={idNamingConversion('Change Language')} key={'change-language'} onClick={() => showLangModal()}>
                                    Change Language
                                </Menu.Item>
                            </Menu>
                        }>
                        <Space size={[0, 0]} className={clsx(classes.profileIconHover)} id={idNamingConversion('Profile')}>
                            <Image
                                src={ProfileIcon}
                                preview={false}
                            />
                        </Space>
                    </Dropdown>
                    <Dropdown
                        placement="bottomLeft"
                        className={clsx(classes.padddingIconsProfile, classes.primaryMenuColor)}
                        overlay={
                            <Menu className={clsx(classes.MenuColors)}>
                                {helpMenus.map((menus, i) => (
                                    <Fragment key={`${menus}_${i}`}>
                                        {
                                            menus?.sub ?
                                                <SubMenu
                                                    className={clsx(classes.menuArrowIcon)}
                                                    id={idNamingConversion(menus.menu)}
                                                    key={`${menus.menu}_${i}`} gap={0} title={menus.menu}>
                                                    {
                                                        menus.sub.map((menus, i) => {
                                                            return (
                                                                <Fragment key={`${menus}_sub_${i}`}>
                                                                    {
                                                                        checkPermission(menus.menu, 'Admin') &&
                                                                        <Menu.Item id={idNamingConversion(menus.menu)}
                                                                            key={menus.menu} onClick={() => handleMenuOnClick(menus.type, menus.pdf)}>
                                                                            {menus.menu}
                                                                        </Menu.Item>
                                                                    }
                                                                </Fragment>
                                                            )
                                                        })}
                                                </SubMenu>
                                                : <>
                                                    {
                                                        checkPermission(menus.menu, 'Admin') &&
                                                        <Menu.Item id={idNamingConversion(menus.menu)}
                                                            key={menus.menu} onClick={() => handleMenuOnClick(menus.menu)}>
                                                            {menus.menu}
                                                        </Menu.Item>
                                                    }
                                                </>
                                        }
                                    </Fragment>
                                ))}
                            </Menu>
                        }>
                        <Space size={[0, 0]} className={clsx(classes.profileIconHover)} id={idNamingConversion('Help')}>
                            <Image src={HelpIcon} preview={false} />
                        </Space>
                    </Dropdown>
                </Space>
                <Modal
                    title={'Change Password'}
                    width={520}
                    open={isCPModalVisible}
                    onOk={handleCPOk}
                    onCancel={handleCPCancel}
                    footer={null}
                    className={classes.commonPopup}
                    closeIcon={<CloseIcon onClick={() => handleCPCancel()} />}>
                    <Space direction={'vertical'} className={classes.modalPaper}>
                        <Box
                            className={clsx(classes.loginForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            id="change-password-submit"
                            onSubmit={(e) => handleChangePassword(e)} >
                            <TextField autoComplete='one-time-code'
                                label='Old Password'
                                type={passwordOldShown ? "text" : "password"}
                                fullWidth
                                variant={'standard'}
                                error={errorOldPassword && true}
                                helperText={errorOldPassword}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                    endAdornment: (
                                        <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordOldShown(!passwordOldShown)} position="end" >
                                            <IconButton tabIndex={-1}>
                                                {passwordOldShown ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setoldPassword(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='New Password'
                                type={passwordNewShown ? "text" : "password"}
                                fullWidth
                                variant={'standard'}
                                error={errorNewPassword && true}
                                helperText={errorNewPassword}
                                className={clsx(classes.margin30t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                    endAdornment: (
                                        <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordNewShown(!passwordNewShown)} position="end" >
                                            <IconButton tabIndex={-1}>
                                                {passwordNewShown ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setnewPassword(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Confirm Password'
                                type={passwordConfirmShown ? "text" : "password"}
                                fullWidth
                                variant={'standard'}
                                error={errorConfirmPassword && true}
                                helperText={errorConfirmPassword}
                                className={clsx(classes.margin30t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                    endAdornment: (
                                        <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordConfirmShown(!passwordConfirmShown)} position="end" >
                                            <IconButton tabIndex={-1}>
                                                {passwordConfirmShown ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => setconfirmPassword(e.target.value)}
                            />
                            <Button
                                key='save'
                                type='submit'
                                color='primary'
                                variant="contained"
                                fullWidth
                                className={clsx(classes.modalBtn, classes.bold, { [classes.loading]: changePasswordLoader })}
                            >Save New Password</Button>
                        </Box>
                    </Space>
                </Modal>

                <Modal
                    title={'Change Email ID'}
                    width={520}
                    open={isEmailModalVisible}
                    onOk={handleEmailOk}
                    onCancel={handleEmailCancel}
                    footer={null}
                    className={classes.commonPopup}
                    closeIcon={<CloseIcon onClick={() => handleEmailCancel()} />}
                >
                    <Space direction={'vertical'} className={classes.modalPaper}>
                        <Box
                            className={clsx(classes.loginForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            id="verify-password"
                            onSubmit={(e) => handleVerifyPassword(e, 'email')} >
                            <Typography variant={'subtitle1'} style={{ fontSize: '13px' }}>Enter Password to update your registered Email ID</Typography>
                            <TextField autoComplete='one-time-code'
                                label='Password'
                                value={password}
                                type={passwordEmailShown ? "text" : "password"}
                                fullWidth
                                variant={'standard'}
                                error={verifyPasswordEmailErrorMessage && true}
                                helperText={verifyPasswordEmailErrorMessage}
                                className={classes.margin10t}
                                onChange={(e) => setPassword(e.target.value)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                    endAdornment: (
                                        <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordEmailShown(!passwordEmailShown)} position="end" >
                                            <IconButton tabIndex={-1}>
                                                {passwordEmailShown ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                            />
                            <Button
                                key='verify'
                                type='submit'
                                color='primary'
                                variant="contained"
                                fullWidth
                                className={clsx(classes.modalBtn, classes.bold, { [classes.loading]: verifyPasswordLoader })}>
                                Verify
                            </Button>
                        </Box>
                    </Space>
                </Modal>
                <Modal
                    title={'Change Mobile Number'}
                    width={520}
                    open={isMobileModalVisible}
                    onOk={handleMobileOk}
                    onCancel={handleMobileCancel}
                    footer={null}
                    className={classes.commonPopup}
                    closeIcon={<CloseIcon onClick={() => handleMobileCancel()} />}
                >
                    <Space direction={'vertical'} className={classes.modalPaper}>
                        <Box
                            className={clsx(classes.loginForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            id="verify-password"
                            onSubmit={(e) => handleVerifyPassword(e, 'mobile')} >
                            <Typography variant={'subtitle1'} style={{ fontSize: '13px' }}>Enter Password to update your registered Mobile Number</Typography>
                            <TextField autoComplete='one-time-code'
                                label='Password'
                                value={password}
                                type={passwordMobileShown ? "text" : "password"}
                                fullWidth
                                variant={'standard'}
                                error={verifyPasswordMobileErrorMessage && true}
                                helperText={verifyPasswordMobileErrorMessage}
                                className={classes.margin10t}
                                onChange={(e) => setPassword(e.target.value)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    },
                                    endAdornment: (
                                        <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordMobileShown(!passwordMobileShown)} position="end" >
                                            <IconButton tabIndex={-1}>
                                                {passwordMobileShown ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                            />
                            <Button
                                key='verify'
                                type='submit'
                                color='primary'
                                variant="contained"
                                fullWidth
                                className={clsx(classes.modalBtn, classes.bold, { [classes.loading]: verifyPasswordLoader })}
                            >
                                Verify
                            </Button>
                        </Box>
                    </Space>
                </Modal>
                <Modal
                    title={'Change Language'}
                    width={520}
                    open={isLangModalVisible}
                    onOk={handleLangOk}
                    onCancel={handleLangCancel}
                    footer={null}
                    className={classes.commonPopup}
                    closeIcon={<CloseIcon onClick={() => handleLangCancel()} />}>
                    <FormControl
                        tabIndex={-1}
                        className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                        variant={'standard'}
                        fullWidth>
                        <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Select a Language below</FormLabel>
                        <RadioGroup row
                            defaultValue="ACTIVE"
                            aria-labelledby="demo-customized-radios"
                            name="status"
                            className={classes.margin20t}
                            value={1}>
                            {/* {
                            languageDetails && languageDetails?.length > 0 && languageDetails.map((value, i) =>
                                <FormControlLabel key={i} value={value.id} control={<Radio
                                    checkedIcon={<UnSelectedIcon />}
                                    icon={<SelectedIcon />}
                                />} label={value.name} />
                            )
                        } */}
                            <FormControlLabel value={1} control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label={'English'} />
                        </RadioGroup>
                    </FormControl>
                    <Button
                        key='verify'
                        color='primary'
                        variant="contained"
                        fullWidth
                        onClick={() => handleLangCancel()}
                        className={clsx(classes.modalBtn, classes.bold)}>
                        Change Language
                    </Button>
                </Modal>
                <Modal
                    title={'Change Email ID'}
                    width={520}
                    open={isChangeEmailModalVisible}
                    onOk={handleChangeEmailOk}
                    onCancel={handleChangeEmailCancel}
                    footer={null}
                    className={classes.commonPopup}
                    closeIcon={<CloseIcon onClick={() => handleChangeEmailCancel()} />}>
                    <Box
                        className={clsx(classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        id="verify-password"
                        onSubmit={(e) => handleChangeEmail(e)}>
                        <TextField autoComplete='one-time-code'
                            label='Enter New Email ID'
                            fullWidth
                            value={changeEmail}
                            variant={'standard'}
                            error={changeEmailErrorMessage && true}
                            helperText={changeEmailErrorMessage}
                            InputProps={{
                                classes: {
                                    input: classes.textFieldColor,
                                }
                            }}
                            InputLabelProps={{
                                className: classes.textFieldLableColorCustom,
                            }}
                            onChange={(e) => setChangeEmail(e.target.value)}
                        />
                        <Button
                            key='save'
                            type='submit'
                            color='primary'
                            variant="contained"
                            fullWidth
                            className={clsx(classes.modalBtn, { [classes.loading]: changeEmailLoader })}>
                            Save
                        </Button>
                    </Box>
                </Modal>
                <Modal
                    title={'Change Mobile Number'}
                    width={520}
                    open={isChangeMobileModalVisible}
                    onOk={handleChangeMobileOk}
                    onCancel={handleChangeMobileCancel}
                    footer={null}
                    className={classes.commonPopup}
                    closeIcon={<CloseIcon onClick={() => handleChangeMobileCancel()} />} >
                    <Box
                        className={clsx(classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        id="verify-password"
                        onSubmit={(e) => handleChangeMobile(e)}>
                        <TextField autoComplete='one-time-code'
                            placeholder='Enter New Mobile Number'
                            type='number'
                            fullWidth
                            value={changeMobile}
                            variant={'standard'}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">(+91) </InputAdornment>,
                                classes: {
                                    input: classes.textFieldColor,
                                }
                            }}
                            onWheel={(e) => e.target.blur()}
                            InputLabelProps={{
                                className: classes.textFieldLableColorCustom,
                            }}
                            error={changeMobileErrorMessage && true}
                            helperText={changeMobileErrorMessage}
                            onChange={(e) => setChangeMobile(e.target.value)}
                        />
                        <Button
                            key='save'
                            type='submit'
                            color='primary'
                            variant="contained"
                            fullWidth
                            className={clsx(classes.modalBtn, { [classes.loading]: changeEmailLoader })}>
                            Save
                        </Button>
                    </Box>
                </Modal>
                <Modal
                    title={'Success Message'}
                    width={520}
                    open={successModalVisible}
                    onOk={handleSuccessOk}
                    onCancel={handleSuccessCancel}
                    footer={null}
                    className={clsx(classes.commonPopup)}
                    closeIcon={<CloseIcon onClick={() => handleSuccessCancel()} />}>
                    {successMessage}
                </Modal>
                <CustomerLeaderBoard
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={leaderBoardVisible}
                    onLeaderBoardVisible={(v) => setLeaderBoardVisible(v)} />
                <SalesPaymentStatement
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={salesPaymentVisible}
                    onSalesPaymentVisible={(v) => setSalesPaymentVisible(v)} />
                <StaffSalesCollectionStatement
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={staffSalesCollectionVisible}
                    onStaffSalesCollectionVisible={(v) => setStaffSalesCollectionVisible(v)} />
                <SalesPriceDeviation
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={salesPriceDeviationVisible}
                    onSalesPriceDeviationVisible={(v) => setSalesPriceDeviationVisible(v)} />
                <Top10Supplier
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={topSupplierVisible}
                    onTopSupplierVisible={(v) => setTopSupplierVisible(v)} />
                <ResaleValueReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={resaleValueVisible}
                    onResaleValueVisible={(v) => setResaleValueVisible(v)} />
                <StockValueReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={stockValueVisible}
                    onStockValueVisible={(v) => setStockValueVisible(v)} />
                <TransferValueReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={transferValueVisible}
                    onTransferValueVisible={(v) => setTransferValueVisible(v)} />
                <NetOrderReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={netOrderVisible}
                    onNetOrderVisible={(v) => setNetOrderVisible(v)} />
                <ProductAnalysis
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={productAnalysisVisible}
                    onProductAnalysisVisible={(v) => setProductAnalysisVisible(v)} />
                <ProductGroupAnalysis
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={productGroupAnalysisVisible}
                    onProductAnalysisVisible={(v) => setProductGroupAnalysisVisible(v)} />
                <TopProductsSupply
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={topProductsSupplyVisible}
                    onProductAnalysisVisible={(v) => setTopProductsSupplyVisible(v)} />
                <SalesLocation
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={salesLocationVisible}
                    onSalesLocationVisible={(v) => setSalesLocationVisible(v)} />
                <CustomerAgedDues
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={customerAgedDuesVisible}
                    onCustomerAgedDuesVisible={(v) => setCustomerAgedDuesVisible(v)} />
                <InactiveCustomers
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={inaciveCustomersVisible}
                    onInactiveCustomersVisible={(v) => setInaciveCustomersVisible(v)} />
                <ShortCutKeys
                    visible={shortCutVisible}
                    onClose={() => setShortCutVisible(!shortCutVisible)}
                    classes={classes}
                />
                <PDFViewer
                    visible={pdfVisible}
                    pdfName={pdfName}
                    type={menuTitle}
                    onClose={() => { setPdfVisible(!pdfVisible); setPdfName('') }}
                    classes={classes}
                />
            </div>
            <MobileMenus {...props}
                handleMenuOnClick={(data) => handleMenuOnClick(data)}
                handleClose={() => props.handleClose()}
                mobileMenuVisible={props.mobileMenuVisible}
                logoutUser={() => logoutUser(props)}
                showCPModal={() => showCPModal()}
                showEmailModal={() => showEmailModal()}
                showMobileModal={() => showMobileModal()}
                showLangModal={() => showLangModal()}
            />
        </Fragment>
    )
}